export const arrayEqualsShallow = <T>(a?: T[], b?: T[]): boolean =>
    Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, i) => val === b[i]);
